import { useContext } from "react";
import { divisionAccesses } from "../../constants";
import { hasDivisionAccess } from "../../services/accountService";
import useDecodeToken from "../../hooks/useDecodeToken";

export function RestrictedContent({
  children = <></>,
  allowedDivisionAccesses = [divisionAccesses.network],
}) {
  // const decodedUserToken = useContext(UserProfileContext);
  const [decodedUserToken] = useDecodeToken();
  const isAllowed = hasDivisionAccess(
    decodedUserToken,
    allowedDivisionAccesses
  );
  // console.log(decodedUserToken);
  return isAllowed ? children : null;
}
